const LOADING_SELECTOR = "dlt-loading";

export function addLoading(transparent = false): void {
  const hasLoading = isLoading();

  if (hasLoading) return;

  const loadingElement = document.createElement(LOADING_SELECTOR);
  if(transparent) {
    loadingElement.style.setProperty("--dlt-backdrop-background-color", "transparent");
  }

  document.body.appendChild(loadingElement);
}

export function removeLoading(): void {
  const loadingElement = isLoading();

  if (!loadingElement) return;

  document.body.removeChild(loadingElement);
}

export function isLoading(): HTMLDltLoadingElement | null {
  const loadingElement = document.body.querySelector(LOADING_SELECTOR);

  if (!loadingElement) return null;

  return loadingElement;
}
